import * as React from "react";
import { useCallback } from "react";
import { useFormikContext } from "formik";
import EventProcedureStepForm from "../EventProcedureStepForm";
function NewStepModalFormik({ onClose }) {
  const {
    values: { steps },
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const handleSaveStep = useCallback(
    (newStep) => {
      setFieldValue("steps", [...steps, newStep]);
      setFieldTouched("steps", true);
      onClose();
    },
    [setFieldTouched, setFieldValue, onClose, steps]
  );
  return /* @__PURE__ */ React.createElement(EventProcedureStepForm, { onClose, onSave: handleSaveStep });
}
export default NewStepModalFormik;
